export const concat = (
	values: (string | number | undefined | null)[],
	separator = ' '
): string =>
	values
		.filter(Boolean)
		.map((value) => value?.toString().trim() ?? '')
		.join(separator);

export const capitalizeFirstLetter = (text?: string) => {
	if (!text) return '';
	return (
		text.trim().charAt(0).toUpperCase() + text.trim().slice(1).toLowerCase()
	);
};

export const capitalizeEachWord = (string: string | undefined | null) => {
	if (!string) return '';
	return string
		.split(' ')
		.map((elem) => capitalizeFirstLetter(elem.trim()))
		.join(' ');
};

export const capitalize = (string: string | undefined | null) => {
	return (
		string && string.trim().charAt(0).toUpperCase() + string.trim().slice(1)
	);
};

export const capitalizeAllString = (string: string | undefined | null) => {
	return string?.toUpperCase();
};

export const pluralize = (string: string | undefined | null, n: number) => {
	return string && n > 1 ? `${string}s` : string;
};

export const removeAccents = (str: string) =>
	str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const match = (src: string, compare: string) =>
	src.toLowerCase().includes(compare.toLowerCase().trim());

export const emptyString = (data?: string | null): boolean => {
	return data === undefined || data === null || data.trim().length === 0;
};
